import { PaneArea, Point } from '../../types/shared'
import Polygon, { IPolygonAttrs } from '../canvas/polygon'
import PaneModel from '../models/pane'

export type Area = PaneArea
type Attrs = IPolygonAttrs
type PartialAttrs = Partial<Attrs>

class PolygonCreator extends Polygon<Attrs & Pick<IPolygonAttrs, 'points'>> {
  mouseDowns = 1
  isCreator = true
  lastMouseDown: Point = { x: 0, y: 0 }

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(
      {
        ...values,
        points: [
          {
            x: startArea.x,
            y: startArea.y,
          },
        ],
      },
      model
    )
    this.mouseDowns = 0
    this.onMouseDown(startArea)
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  isSamePoint = ({ pointA, pointB, margin }: { pointA: Point; pointB: Point; margin: Point }) =>
    pointA.x - margin.x <= pointB.x &&
    pointB.x <= pointA.x + margin.x &&
    pointA.y - margin.y <= pointB.y &&
    pointB.y <= pointA.y + margin.y

  onMouseDown(area: Area) {
    this.mouseDowns++
    const first = this.attrs.points[0]
    const margin = {
      x: this.model.scale.x.invert(5),
      y: this.model.scale.y.invert(0) - this.model.scale.y.invert(5),
    }

    if (this.mouseDowns !== 1 && this.isSamePoint({ pointA: first, pointB: area, margin })) {
      this.attrs.points[this.attrs.points.length - 1] = {
        x: first.x,
        y: first.y,
      }
      this.release()
      this.replaceMyself(Polygon.fromObject<Polygon>(this.attrs, this.model))
      this.toolsCallback()
    } else if (this.mouseDowns !== 1 && this.isSamePoint({ pointA: this.lastMouseDown, pointB: area, margin })) {
      this.attrs.points.pop()
      this.release()
      this.replaceMyself(Polygon.fromObject<Polygon>(this.attrs, this.model))
      this.toolsCallback()
    } else {
      this.attrs.points[this.mouseDowns] = { x: area.x, y: area.y }
    }
    this.lastMouseDown = { x: area.x, y: area.y }
    this.trigger('change')
  }

  onMouseMove(area: Area) {
    this.attrs.points[this.mouseDowns].x = area.x
    this.attrs.points[this.mouseDowns].y = area.y
    this.trigger('change')
  }

  isInArea() {
    return true
  }
}

export default PolygonCreator
